import React, { useState, useEffect, useRef } from 'react';
import {
  Flex,
  Text,
  Button,
  View,
  IconButton,
  IconTrashLine,
  IconCertifiedSolid,
  IconCertifiedLine,
  IconMoreLine,
  CloseButton,
  Tooltip,
  Menu,
  Popover,
  Spinner
} from '@smarterservices/smarter-ui';
import { getStore } from '../../../../../stores/StoreContext';
import { useFullScreenMountNode } from '../../../../../contexts/FullScreenContext';
const ReviewerTools = ({
  annotation,
  onConfirm,
  onUnreview,
  onDelete,
  onClose,
}) => {

  const [showUnReviewTooltip, setShowUnReviewTooltip] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const [deleteConfirmMode, setDeleteConfirmMode] = useState(false);
  const [confirmationUpdating, setConfirmationUpdating] = useState(false);
  
  // Get the appropriate mount node for full screen support
  const mountNode = useFullScreenMountNode();
  const tooltipTriggerRef = useRef(null);
  const menuTriggerRef = useRef(null);
  const ExamSessionStore = getStore('examSessionStore');


  // calls to confirm this is a valid annotation...
    const handleConfirm = React.useCallback(async () => {
      setConfirmationUpdating(true);
      // Implement delete functionality
      const result = await ExamSessionStore.updateAnnotation(annotation.sid, {
        //TODO: Update the users name...
        reviewedBy: 'admin',
        reviewedDate: new Date().toISOString(),
        updatedBy: 'admin',
        updatedDate: new Date().toISOString(),
      });

      setConfirmationUpdating(false);

      if(result.success){
        onConfirm(result);  
      }

    }, [ExamSessionStore, annotation.sid]);
  
    const handleUnreview = React.useCallback(async () => {
      setShowUnReviewTooltip(false);
      setConfirmationUpdating(true);      
      // Implement delete functionality
      const result = await ExamSessionStore.updateAnnotation(annotation.sid, {
        //TODO: Update the users name...
        reviewedBy: null,
        reviewedDate: null,
        updatedBy: 'admin',
        updatedDate: new Date().toISOString(),
      });

      setConfirmationUpdating(false);

      if(result.success){
        onUnreview(result);  
      }
    }, [ExamSessionStore, annotation.sid]);
  
    const handleDelete = React.useCallback(async () => {
      // Implement delete functionality
      const result = await ExamSessionStore.deleteAnnotation(annotation.sid);
      //setShowContextMenu(false);
    }, [ExamSessionStore, annotation.sid]);

  return (
    <View
      as="div"
      withVisualDebug={false}
      borderRadius="small"
      position="relative"
    >
      <Flex as="div" withVisualDebug={false}>
        <Flex.Item>
          <Popover
            on="click"
            placement="bottom center"
            isShowingContent={showMenu}
            onShowContent={() => setShowMenu(true)}
            onHideContent={() => {
              setShowMenu(false);
              setDeleteConfirmMode(false);
              onClose(annotation);
            }}
            offsetY={4}
            constrain="window"
            mountNode={() => mountNode}
            renderTrigger={
              <IconButton
                size="small"
                color="primary"
                margin="none x-small none none"
                screenReaderLabel="More options"
                withBackground={false}
                withBorder={false}
                elementRef={(el) => {
                  menuTriggerRef.current = el;
                }}
              >
                <IconMoreLine />
              </IconButton>
            }
          >
            <Menu>
              {!deleteConfirmMode ? (
                <Menu.Item
                  renderIcon={<IconTrashLine />}
                  onSelect={() => {
                    setDeleteConfirmMode(true);
                  }}
                >
                  Delete
                </Menu.Item>
              ) : (
                <Menu.Item renderIcon={<IconTrashLine />}>
                  <Flex>
                    <Flex.Item padding="0 small 0 0">
                      <Text>Sure?</Text>
                    </Flex.Item>
                    <Flex.Item>
                      <Button
                        size="small"
                        color="danger"
                        margin="0 0 0 x-small"
                        onClick={() => {
                          onDelete();
                          setDeleteConfirmMode(false);
                          setShowMenu(false);
                        }}
                      >
                        Yes
                      </Button>
                    </Flex.Item>
                  </Flex>
                </Menu.Item>
              )}

              {/* <Menu.Item
                onSelect={() => {
                  console.log('Share annotation');
                  setShowMenu(false);
                }}
              >
                Adjust Position
              </Menu.Item> */}
            </Menu>
          </Popover>

          {!annotation.reviewedDate ? (
            <IconButton
              size="small"
              margin="none x-small none none"
              screenReaderLabel="Edit Annotation"
              onClick={handleConfirm}
            >
              
              {confirmationUpdating ? <Spinner size="x-small" /> : <IconCertifiedLine />}
            </IconButton>
          ) : (
            // the annotation has been reviewed...
            <Tooltip
              renderTip={
                <View
                  as="div"
                  padding="small"
                  background="primary"
                  borderRadius="small"
                >
                  <Flex direction="column">
                    <Flex.Item>
                      <Text color="primary-inverse" size="small">
                        Remove review status?
                      </Text>
                    </Flex.Item>
                    <Flex.Item>
                      <Flex direction="row" gap="x-small" justifyItems="end">
                        <Flex.Item padding="xx-small">
                          <Button
                            size="small"
                            onClick={handleUnreview}
                          >
                            Yes
                          </Button>
                        </Flex.Item>
                        <Flex.Item padding="xx-small">
                          <Button
                            size="small"
                            onClick={() => setShowUnReviewTooltip(false)}
                          >
                            No
                          </Button>
                        </Flex.Item>
                      </Flex>
                    </Flex.Item>
                  </Flex>
                </View>
              }
              placement="bottom"
              color="primary"
              offsetY={5}
              mountNode={mountNode}
              isShowingContent={showUnReviewTooltip}
              onShowContent={() => setShowUnReviewTooltip(true)}
              onHideContent={() => setShowUnReviewTooltip(false)}
            >
              <IconButton
                size="small"
                color="success"
                margin="none x-small none none"
                screenReaderLabel="Delete Annotation"
                onClick={() => setShowUnReviewTooltip(!showUnReviewTooltip)}
                elementRef={(el) => {
                  tooltipTriggerRef.current = el;
                }}
              >
                <IconCertifiedSolid />
              </IconButton>
            </Tooltip>
          )}

          <CloseButton
            offset="small"
            onClick={() => {
              ExamSessionStore.setManagingAnnotation(null);
              onClose(annotation);
            }}
            screenReaderLabel="Close"
          />
        </Flex.Item>
      </Flex>
    </View>
  );
};

export default ReviewerTools;
